var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarketplace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3c2.047 0 3.706 1.621 3.706 3.621v.107h.82c.906 0 1.68.64 1.828 1.513l1.605 9.41c.268 1.567-.815 3.049-2.419 3.31a3.01 3.01 0 01-.484.039H6.943C5.318 21 4 19.712 4 18.124c0-.158.013-.316.04-.473l1.605-9.41c.15-.873.922-1.513 1.828-1.513h.82V6.62C8.294 4.621 9.954 3 12 3zM9.275 9.39a.754.754 0 00-.763.746c0 .412.341.746.763.746a.754.754 0 00.763-.746.754.754 0 00-.763-.745zm5.45 0a.754.754 0 00-.763.746c0 .412.341.746.763.746a.754.754 0 00.763-.746.754.754 0 00-.763-.745zM12 4.492c-1.204 0-2.18.954-2.18 2.13h4.36c0-1.176-.976-2.13-2.18-2.13z"
  })));
}

export default SvgMarketplace;